import { TypeSubscriptionRecord } from '@/lib/api/subscriptionManager/types';
import {
  isBabylistSubscription,
  isGroupGiftingMigratedSubscription,
} from '@/lib/api/subscriptionManager/helpers';

export function _getBaseZendeskLink(locale?: string) {
  switch (locale) {
    case 'en-US':
      return 'https://help.lovevery.com/hc/en-us/requests/new';
    case 'en-AU':
      return 'https://loveveryaustralia.zendesk.com/hc/en-us/requests/new';
    case 'en-GB':
    case 'en-EU':
      return 'https://loveveryeurope.zendesk.com/hc/en-us/requests/new';
    case 'nl':
      return 'https://loveveryeurope.zendesk.com/hc/nl/requests/new';
    case 'fr':
      return 'https://loveveryeurope.zendesk.com/hc/fr/requests/new';
    case 'de':
      return 'https://loveveryeurope.zendesk.com/hc/de/requests/new';
    case 'es':
      return 'https://loveveryeurope.zendesk.com/hc/es/requests/new';
    default:
      return 'https://help.lovevery.com/hc/en-us/requests/new';
  }
}

export function generateZendeskLink(
  locale: string | undefined,
  params?: string[],
) {
  const baseLink = _getBaseZendeskLink(locale);
  const queryString =
    params && params.length > 0 ? `?${params?.join('&')}` : '';

  return `${baseLink}${queryString}`;
}

export function generateSkipPrepaidKitZendeskLink(
  subjectLine: string,
  locale?: string,
) {
  const requestType = 'tf_360037564071=managing_my_account_or_subscription';
  const requestDetail = 'tf_360038039112=skip_a_play_kit';

  return generateZendeskLink(locale, [requestType, requestDetail, subjectLine]);
}

export function generateCancelSpecialSubscriptionZendeskLink(
  subscription: TypeSubscriptionRecord,
  locale?: string,
) {
  const subscriptionType = _getSubscriptionType(subscription);
  const { uuid } = subscription;

  const requestType = 'tf_360037564071=cancel_my_subscription';
  const subjectLine = `tf_subject=Request to cancel ${subscriptionType} subscription: ${uuid}`;
  return generateZendeskLink(locale, [requestType, subjectLine]);
}

function _getSubscriptionType(subscription: TypeSubscriptionRecord) {
  if (isBabylistSubscription(subscription)) {
    return 'Babylist';
  }

  if (isGroupGiftingMigratedSubscription(subscription)) {
    return 'Group Gifting Migrated';
  }

  return '';
}
